import firebase from 'firebase/compat/app';
import { environment } from '../environments/environment';
import 'firebase/compat/messaging';

if (typeof window !== 'undefined' && !firebase.apps.length) {
  firebase.initializeApp(environment.firebaseConfig);
}

/** Undefined on the server or when the browser cannot run FCM. */
let messaging: firebase.messaging.Messaging | undefined;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  messaging = firebase.messaging();
}

export { messaging };
